<template>
  <div
    class="jin10-datepicker"
    :class="{ 'picker-visible': datePickerPanelShow }"
    v-click-outside="onClosePicker"
  >
    <!-- <i class="ushk-icon ushk-icon_calendar"></i> -->

    <span
      class="jin10-datepicker__input"
      @click="handleTriggerDate"
    >
      {{ dateValueText }}
      <i class="ushk-icon ushk-icon_triangle"></i>
    </span>
    <span
      class="jin10-datepicker__input jin10-datepicker__mb-input"
      @click="handleTriggerDate"
    >
      {{ mobileDateValueText }}
    </span>

    <button v-if="notToday" class="jin10-datepicker__button" @click="backToday">
      <i class="ushk-icon ushk-icon_today"></i>
      回到今天
    </button>

    <slot name="right"></slot>

    <jin-date-picker-panel
      ref="datePickerPanel"
      v-model="datePickerPanelShow"
      placement="right"
      :initDate="value"
      @pick="onDatePick"
      @open="onDatePickerOpen"
    />
  </div>
</template>

<script>
import JinDatePickerPanel from './JinDatePicker/JinDatePickerPanel.vue'

export default {
  name: 'UshkDatepicker',
  props: {
    options: {
      type: Object,
      default() {
        return {}
      },
    },
    name: String,
    placeholder: String,
    val: String,
    value: {},
    className: String,
  },

  components: {
    JinDatePickerPanel,
  },

  data() {
    return {
      datePickerPanelShow: false,
      interVal: this.value,
      flatPickr: null,
    }
  },

  computed: {
    dateValueText() {
      return (this.value || new Date()).format('yyyy年MM月')
    },
    mobileDateValueText() {
      return (this.value || new Date()).format('yyyy-MM-dd')
    },
    notToday() {
      return (
        (this.value || new Date()).format('yyyyMMdd') !==
        new Date().format('yyyyMMdd')
      )
    },
  },

  methods: {
    backToday() {
      this.$emit('input', new Date())
    },
    onDatePick(param = {}) {
      const { date } = param
      this.$emit('input', date)
    },
    onDatePickerOpen() {
      this.updatePickerSelectedDate()
    },
    updatePickerSelectedDate() {
      this.$nextTick(() => {
        this.$refs.datePickerPanel &&
          this.$refs.datePickerPanel.setDate(this.value)
      })
    },
    handleTriggerDate() {
      this.datePickerPanelShow = !this.datePickerPanelShow
    },
    onClosePicker() {
      this.datePickerPanelShow = false
    },
  },
}
</script>

<style lang="scss">
@import "~@/styles/helpers/_function.scss";

$datepicker-prefix-cls: 'jin10-datepicker';
$datepickerHeight: 28px;

.#{$datepicker-prefix-cls} {
  max-width: 100%;
  position: relative;
  height: $datepickerHeight;
  display: inline-flex;
  align-items: center;
  color: #fff;
  font-size: 16px;

  &.picker-visible {
    .ushk-icon_down {
      transform: rotate(-180deg);
    }
  }

  .ushk-icon {
    font-size: 16px;
    // color: #666;
  }

  
  .jin10-icon_close {
    margin-top: -8px;
    cursor: pointer;
    display: none;
    &:hover {
      opacity: 0.8;
    }
  }
  &:hover {
    .jin10-icon_datepicker {
      display: none;
    }
    .jin10-icon_close {
      display: block;
    }
  }
  &__input {
    display: flex;
    align-items: center;
    background-color: transparent;
    border: none;
    color: #000;
    font-weight: 600;
    // margin-left: 16px;
    cursor: pointer;

    &::before {
      content: '';
      display: block;
      width: 20px;
      height: 20px;
      background: url('../assets/img/icon-calendar.png') no-repeat top left/100%;
      margin-right: 6px;
    }

    &.jin10-datepicker__mb-input {
      display: none;
    }
    .ushk-icon_triangle {
      color: #333;
      font-weight: 400 !important;
    }
  }
  &__button {
    margin-left: 50px;
    white-space: nowrap;
    background: transparent;
    color: #000;
    border: 0;
    &:hover {
      &, .ushk-icon_today {
        color: $colorText;
      }
    }
  }
  &__button, .ushk-icon_today {
    font-size: 14px;
  }

  @include max-screen(768px) {
    display: flex;
    &__input {
      margin-left: 12px;
    }
    &__button {
      display: none;
      margin-left: 20px;
    }
    &__button, .ushk-icon_today {
      font-size: 12px;
    }
  }

  @include max-screen(540px) {
    &__input {
      display: none;
      margin-left: 8px;
      &.jin10-datepicker__mb-input {
        display: inline-block;
      }
    }
    .ushk-icon {
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// DatePicker.vue?5e830655